export default "__VITE_ASSET__Cn$5QCns__"